var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-details sdr-box",
      class: {
        flightIsNotRebookable: !_vm.get_GotFlightsToRebook({
          flightdirection: _vm.flightdirection,
        }),
      },
      staticStyle: {
        "padding-left": "0px",
        "padding-right": "0px",
        "background-color": "#dedede",
        color: "#2d3e52",
        padding: "7px",
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-6" }, [
          _c("div", { staticStyle: { "padding-top": "25px" } }, [
            _c("input", {
              staticStyle: { float: "left", "margin-right": "10px" },
              attrs: {
                type: "checkbox",
                id: "allPax_" + _vm.flightdirection,
                name: "allPax_" + _vm.flightdirection,
                disabled: !_vm.get_GotFlightsToRebook({
                  flightdirection: _vm.flightdirection,
                }),
              },
              on: {
                change: function ($event) {
                  _vm.onChange_Checkbox_AllPaxOnFlight($event)
                },
              },
            }),
            _vm._v(" "),
            _vm.flightdirection === "outward"
              ? _c(
                  "label",
                  { attrs: { for: "allPax_" + _vm.flightdirection } },
                  [
                    _vm._v(
                      _vm._s(_vm.allpassengersoutward[_vm.getCurrentLocale])
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.flightdirection === "return"
              ? _c(
                  "label",
                  { attrs: { for: "allPax_" + _vm.flightdirection } },
                  [
                    _vm._v(
                      _vm._s(_vm.allpassengersreturn[_vm.getCurrentLocale])
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-6" }, [
          _vm.flightdirection === "outward"
            ? _c("label", [
                _vm._v(_vm._s(_vm.newdateoutward[_vm.getCurrentLocale])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.flightdirection === "return"
            ? _c("label", [
                _vm._v(_vm._s(_vm.newdatereturn[_vm.getCurrentLocale])),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "datepicker-wrap": _vm.get_GotFlightsToRebook({
                  flightdirection: _vm.flightdirection,
                }),
              },
            },
            [
              _c("input", {
                staticClass: "input-text full-width",
                attrs: {
                  type: "text",
                  id: "newDate_" + _vm.flightdirection,
                  name: "newDate_" + _vm.flightdirection,
                  disabled: !_vm.get_GotFlightsToRebook({
                    flightdirection: _vm.flightdirection,
                  }),
                },
              }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }